export default "__VITE_ASSET__a8ec36ee__"